export class SearchRangeFilter {
  public field: string;
  public start: string;
  public end: string;
  public query: string;
}
